import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { formatPrice } from '../../../data/helpers';

const Wrapper = styled(Link)`
  display: flex;
  gap: 10px;
  padding: 8px;
  border-radius: ${({ theme }) => theme.metrics.radius.small};
  color: inherit;
  transition: background 0.2s;

  &:hover {
    background: ${({ theme }) => theme.colors.bgSecondary};
    color: inherit;
  }
`;

const Image = styled.div`
  width: 45px;
  height: 60px;
  background: ${({ theme }) => theme.colors.bgSecondary};
  border-radius: ${({ theme }) => theme.metrics.radius.small};
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Info = styled.div`
  flex: 1;
  min-width: 0;
`;

const Title = styled.div`
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Price = styled.div`
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  color: ${({ theme }) => theme.colors.primary.main};
  font-weight: 600;
  margin-top: 4px;
`;

export default function BookCardSmall({ id, title, coverImage, price }) {
  return (
    <Wrapper to={`/libro/${id}`}>
      <Image>
        {coverImage && <img src={coverImage} alt={title} />}
      </Image>
      <Info>
        <Title>{title}</Title>
        <Price>{formatPrice(price)}</Price>
      </Info>
    </Wrapper>
  );
}
